/* Cart-koopjes: koopjes uit de Checkout Koopjes-app als swipe-rij onder de
   producten, in de lade (.cn-koopjes-mount) en op de winkelwagenpagina
   (.cn-koopjes-mount--page). Gegevens: window.CN_KOOPJES uit
   snippets/cn-koopjes.liquid.

   - Welke: koopjes waarvan de regels kloppen, hoogste prioriteit eerst (lade
     max CN_KOOPJES.max, winkelwagenpagina max 3). Zoals in de kassa valt een
     koopje alleen weg als de klant hetzelfde product zelf in de winkelwagen
     heeft (een regel zonder _koopje_id).
   - A/B-test (CN_KOOPJES.ab): elke winkelwagen krijgt vast variant A of B en
     ziet alleen de koopjes van die variant, in de volgorde uit de app, met
     de korting van die variant als de test er een heeft. Zie abVariant() en
     korting().
   - Toevoegen: één stuk met de kenmerken _koopje_id en _koopje_block (bij
     een test ook _koopje_test en _koopje_variant). De korting geeft de
     kortingsfunctie van de app (koopje-korting); daarna
     tekenen lade en winkelwagenpagina de nieuwe regel met die korting. De
     kaart blijft staan: elke klik voegt er een bij, net als in de kassa.
   - Tekenen: assets/cn-cart.js roept render(cart) aan bij elke weergave van
     de lade; verder luisteren we naar cart:updated. Staat er al hetzelfde,
     dan blijft de DOM staan (geen sprong in de swipe-rij).
   - Meten: "impression" en "add" naar de app (zie meld()); gekocht telt de
     app zelf uit de bestelling.
   - Geen timers of animaties: na het tekenen doet dit blok niets meer. */
(function () {
  'use strict';
  var D = window.CN_KOOPJES;
  if (!D || !Array.isArray(D.koopjes) || !D.koopjes.length || window.cnKoopjes) return;

  /* Plus-icoon van de snelkoopknop op de productkaarten (product-card__btn). */
  var PLUS = '<svg viewBox="0 0 24 26" fill="none" aria-hidden="true"><path d="M12 8.89062V16.8906" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><path d="M8 12.8906H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>';
  /* Even een vinkje na toevoegen; daarna weer het plusje. */
  var VINK = '<svg viewBox="0 0 24 26" fill="none" aria-hidden="true"><path d="M7.5 13.4l3 3 6-6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>';
  var MAX_PAGINA = 3;
  var lastCart = null;
  var keuze = {};
  var bezig = false;

  function money(c) {
    return typeof window.cnMoney === 'function' ? window.cnMoney(c) : '€' + (c / 100).toFixed(2).replace('.', ',');
  }
  function rate() {
    var r = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function koopje(id) {
    for (var i = 0; i < D.koopjes.length; i++) if (String(D.koopjes[i].id) === String(id)) return D.koopjes[i];
    return null;
  }
  function huidige(k) {
    var id = keuze[k.id];
    for (var i = 0; i < k.varianten.length; i++) if (k.varianten[i].id === id) return k.varianten[i];
    return k.varianten[0];
  }
  /* Prijs na de korting, zoals Shopify hem uitrekent: de korting wordt naar
     beneden afgerond (20% van €3,99 = 79 cent, dus €3,20). */
  function koopjesPrijs(k, v) {
    var kort = korting(k);
    var w = Number(kort.waarde) || 0;
    if (kort.type === 'percentage') return v.prijs - Math.floor(v.prijs * w / 100 + 1e-9);
    if (kort.type === 'fixed') return Math.max(0, v.prijs - Math.round(w * 100 * rate()));
    return v.prijs;
  }
  /* Welke optie verschilt tussen de aangeboden varianten (bv. de smaak)? */
  function keuzeOptie(k) {
    if (k.varianten.length < 2) return -1;
    var n = (k.varianten[0].opties || []).length;
    for (var i = 0; i < n; i++) {
      var eerste = k.varianten[0].opties[i];
      for (var j = 1; j < k.varianten.length; j++) if (k.varianten[j].opties[i] !== eerste) return i;
    }
    return -1;
  }

  /* Opties die voor alle aangeboden varianten gelijk zijn (bv. "1 x (50 Gram)"
     bij de reep): klein onder de naam, zodat duidelijk is wat je krijgt. Alleen
     als het product meer varianten heeft dan dit ene. */
  function vasteOpties(k) {
    if (!(k.aantalVarianten > 1)) return '';
    var eerste = k.varianten[0].opties || [];
    var vast = [];
    for (var i = 0; i < eerste.length; i++) {
      var gelijk = k.varianten.every(function (v) { return (v.opties || [])[i] === eerste[i]; });
      if (gelijk && eerste[i] && eerste[i] !== 'Default Title') vast.push(eerste[i]);
    }
    return vast.join(' · ');
  }

  /* Zoals de kassa (Checkout Koopjes, "verbergen zodra het in de winkelwagen
     zit"): alleen regels zonder _koopje_id tellen, en het gaat om het product,
     niet de variant. Een koopje dat al als koopje in de winkelwagen ligt, blijft
     dus staan. */
  function zelfInWinkelwagen(k, cart) {
    return (cart.items || []).some(function (it) {
      var p = it.properties || {};
      return !p._koopje_id && String(it.product_id) === String(k.product);
    });
  }
  function regelsKloppen(k, cart) {
    var regels = Array.isArray(k.regels) ? k.regels : [];
    if (!regels.length) return true;
    var totaal = (cart.items_subtotal_price || cart.total_price || 0) / 100 / rate();
    var producten = (cart.items || []).map(function (it) { return String(it.product_id); });
    var bevat = function (waarde) { return producten.indexOf(String(waarde).split('/').pop()) !== -1; };
    return regels.every(function (r) {
      var t = r && (r.type || r.t);
      var w = r && (r.waarde != null ? r.waarde : r.v);
      if (t === 'cart_min_total') return totaal >= parseFloat(w);
      if (t === 'cart_max_total') return totaal <= parseFloat(w);
      if (t === 'cart_contains_product') return bevat(w);
      if (t === 'cart_excludes_product') return !bevat(w);
      return true;
    });
  }
  /* A/B-test: vast A of B per winkelwagen, zonder cookie of localStorage. Een
     nieuwe winkelwagen loot opnieuw. Regel: FNV-1a (32 bit) over de cart-token
     zonder het deel vanaf "?"; hoogste bit 0 = A, 1 = B. Precies dezelfde
     regel staat in het scriptje van snippets/cn-koopjes-pagina.liquid, zodat
     de lade en /cart hetzelfde tonen. (Liquid kent de cart-token niet; daarom
     kiest ook /cart in de browser, vóór de eerste weergave.) */
  var AB = D.ab && D.ab.test ? D.ab : null;
  function abLetter(t) {
    var h = 0x811c9dc5;
    for (var i = 0; i < t.length; i++) { h ^= t.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 31 ? 'B' : 'A';
  }
  /* 'A' of 'B' voor deze winkelwagen; '' zonder token (dan geen rij). */
  function abVariant() {
    var t = cartToken();
    return t ? abLetter(t) : '';
  }
  /* De korting van een koopje. Heeft de variant van deze winkelwagen een
     eigen korting (ab.korting.a of .b, type none/percentage/fixed), dan geldt
     die voor alle koopjes in de rij; de kortingsfunctie van de app doet
     hetzelfde op grond van _koopje_test en _koopje_variant. */
  function korting(k) {
    var v = AB && AB.korting ? abVariant() : '';
    var eigen = v && AB.korting[v.toLowerCase()];
    return eigen && eigen.type ? eigen : k;
  }

  function kies(cart, max) {
    if (!cart || !cart.item_count) return [];
    var bron;
    if (AB) {
      var v = abVariant();
      var ids = v === 'A' ? AB.a : v === 'B' ? AB.b : null;
      bron = Array.isArray(ids) ? ids.map(koopje).filter(Boolean) : [];
    } else {
      bron = D.koopjes.slice().sort(function (a, b) { return (b.prio || 0) - (a.prio || 0); });
    }
    return bron
      .filter(function (k) { return k.varianten && k.varianten.length && !zelfInWinkelwagen(k, cart) && regelsKloppen(k, cart); })
      .slice(0, max);
  }

  /* Prijs met de klassen van het thema: in de lade die van de lade, op de
     winkelwagenpagina die van de pagina. De kortingsbadge is die van de
     productkaarten (in de winkelwagen standaard verborgen; zie de CSS). */
  function prijsHtml(k, v, pagina) {
    var nu = koopjesPrijs(k, v);
    var pct = v.prijs > 0 ? Math.round((v.prijs - nu) / v.prijs * 100) : 0;
    var badge = pct > 0 ? '<span class="cart-item__discount-badge product-sale-amount-badge">-' + pct + '%</span>' : '';
    if (pagina) {
      var oud = nu < v.prijs ? '<div class="cart-item__price-item--small cart-item__price-item--old">' + money(v.prijs) + '</div>' : '';
      return '<div class="cart-item__price-wrapper"><div class="cart-item__price"><div class="cart-item__price-item">' + money(nu) + '</div>' + oud + '</div>' + badge + '</div>';
    }
    /* is-zichtbaar: daarop kleurt de lade de prijs rood (zie RUSTIGE-PAGINAS),
       style="display: inline" voor de oude regel. */
    var was = nu < v.prijs ? '<span class="cart-item__price-compare is-zichtbaar" style="display: inline;">' + money(v.prijs) + '</span>' : '';
    return '<div class="cart-item__price-wrapper"><span class="cart-item__price-current">' + money(nu) + '</span>' + was + badge + '</div>';
  }
  function kaartHtml(k, pagina) {
    var v = huidige(k);
    var idx = keuzeOptie(k);
    var keuzeHtml = '';
    if (idx >= 0) {
      keuzeHtml = '<select class="cn-koopje__keuze" data-cn-koopje-keuze="' + esc(k.id) + '" aria-label="' + esc((k.opties || [])[idx] || '') + '">' +
        k.varianten.map(function (x) {
          return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.opties[idx]) + '</option>';
        }).join('') + '</select>';
    }
    var label = String(D.labels.voegToe || '').replace(/\{\{\s*title\s*\}\}/, k.titel);
    var vast = vasteOpties(k);
    return '<div class="cn-koopje" data-cn-koopje="' + esc(k.id) + '">' +
      '<img class="cn-koopje__foto" src="' + esc(v.img) + '" alt="" width="52" height="52" loading="lazy">' +
      '<div class="cn-koopje__info"><p class="cn-koopje__naam">' + esc(k.titel) + '</p>' +
      (vast ? '<p class="cn-koopje__optie">' + esc(vast) + '</p>' : '') +
      prijsHtml(k, v, pagina) + keuzeHtml + '</div>' +
      '<button type="button" class="cn-koopje__plus" data-cn-koopje-add="' + esc(k.id) + '" aria-label="' + esc(label) + '">' + PLUS + '</button>' +
      '</div>';
  }
  /* Pijltjes zoals de carrousels van de site (cn-rc__arrow), in het klein.
     Alleen op apparaten met een muis (zie de CSS); op de telefoon swipe je. */
  var PIJL_TERUG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var PIJL_VERDER = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function blokHtml(lijst, pagina) {
    var meer = lijst.length > 1;
    var stippen = meer
      ? '<div class="cn-koopjes__stippen" aria-hidden="true">' + lijst.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>'; }).join('') + '</div>'
      : '';
    var pijlen = meer
      ? '<div class="cn-koopjes__pijlen">' +
        '<button type="button" class="cn-koopjes__pijl" data-cn-koopjes-pijl="-1" aria-label="' + esc(D.labels.vorige || '') + '" disabled>' + PIJL_TERUG + '</button>' +
        '<button type="button" class="cn-koopjes__pijl" data-cn-koopjes-pijl="1" aria-label="' + esc(D.labels.volgende || '') + '">' + PIJL_VERDER + '</button>' +
        '</div>'
      : '';
    return '<div class="cn-koopjes"><div class="cn-koopjes__kop"><p class="cn-koopjes__titel">' + esc(D.labels.kop) + '</p>' + pijlen + '</div>' +
      '<div class="cn-koopjes__rij">' + lijst.map(function (k) { return kaartHtml(k, pagina); }).join('') + '</div>' + stippen + '</div>';
  }

  /* Pijltjes uit aan het begin en eind van de rij (en allebei uit als alles past). */
  function pijlenBijwerken(rij) {
    var blok = rij.closest('.cn-koopjes');
    var terug = blok && blok.querySelector('[data-cn-koopjes-pijl="-1"]');
    var verder = blok && blok.querySelector('[data-cn-koopjes-pijl="1"]');
    if (!terug || !verder) return;
    var max = rij.scrollWidth - rij.clientWidth;
    terug.disabled = rij.scrollLeft <= 2;
    verder.disabled = rij.scrollLeft >= max - 2;
  }
  function handtekening(lijst, pagina, cart) {
    return (pagina ? 'p' : 'l') + '|' + (cart.currency || '') + '|' + lijst.map(function (k) { return k.id + ':' + huidige(k).id; }).join(',');
  }

  /* Stippen volgen de scrollpositie: de kaart waar de rij op staat (aan het
     eind de laatste, ook als er twee tegelijk in beeld zijn). */
  function stippenBijwerken(rij, stippen) {
    if (!stippen.length) return;
    var kaart = rij.querySelector('.cn-koopje');
    var stap = kaart ? kaart.getBoundingClientRect().width + 8 : rij.clientWidth;
    var eind = rij.scrollLeft >= rij.scrollWidth - rij.clientWidth - 2;
    var actief = eind ? stippen.length - 1 : Math.min(stippen.length - 1, Math.round(rij.scrollLeft / stap));
    for (var j = 0; j < stippen.length; j++) stippen[j].classList.toggle('is-active', j === actief);
  }
  function rijVolgen(mount) {
    var rij = mount.querySelector('.cn-koopjes__rij');
    if (!rij) return;
    var stippen = mount.querySelectorAll('.cn-koopjes__stippen span');
    var gepland = false;
    rij.addEventListener('scroll', function () {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(function () { gepland = false; pijlenBijwerken(rij); stippenBijwerken(rij, stippen); });
    }, { passive: true });
    pijlenBijwerken(rij);
    stippenBijwerken(rij, stippen);
  }

  /* Meten in de Checkout Koopjes-app (Analytics, blok Winkelwagen): via de
     app-proxy op het eigen domein, dus geen extra script en geen cookie. De
     sleutel is de cart-token die er al is. Eén keer per koopje per
     winkelwagen; de app ontdubbelt daarnaast per dag. */
  var TRACK = '/apps/cn-koopjes/track';
  /* De winkelwagen uit de pagina (CN_CART, Liquid) heeft geen token; /cart.js
     wel. Anders dezelfde waarde uit Shopify's eigen cart-cookie. */
  function cartToken() {
    var t = lastCart && lastCart.token;
    if (!t) {
      var m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
      try { t = m ? decodeURIComponent(m[1]) : ''; } catch (e) { t = ''; }
    }
    return t ? String(t).split('?')[0] : '';
  }
  function meld(id, soort) {
    if (window.Shopify && window.Shopify.designMode) return;
    var token = cartToken();
    if (!token || !id) return;
    var sleutel = 'cn_kp_' + soort + '_' + id + '_' + token;
    try { if (sessionStorage.getItem(sleutel)) return; } catch (e) {}
    var klaar = function () { try { sessionStorage.setItem(sleutel, '1'); } catch (e) {} };
    var data = { koopjeId: Number(id), eventType: soort, block: 'cart', cartToken: token };
    if (AB) { data.testId = String(AB.test); data.variant = abLetter(token); }
    var body = JSON.stringify(data);
    var weg = false;
    try { weg = !!(navigator.sendBeacon && navigator.sendBeacon(TRACK, new Blob([body], { type: 'application/json' }))); } catch (e) {}
    if (weg) { klaar(); return; }
    try {
      fetch(TRACK, { method: 'POST', body: body, headers: { 'Content-Type': 'application/json' }, keepalive: true })
        .then(function (r) { if (r.ok) klaar(); })
        .catch(function () {});
    } catch (e) {}
  }
  /* "Getoond" = de kaart staat voor minstens de helft in beeld. De dichte lade
     staat buiten beeld (translateX), en een kaart die in de rij nog rechts
     verstopt zit, telt pas na het swipen. */
  var zicht = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (items) {
      items.forEach(function (it) {
        if (!it.isIntersecting || it.intersectionRatio < 0.5) return;
        zicht.unobserve(it.target);
        meld(it.target.getAttribute('data-cn-koopje'), 'impression');
      });
    }, { threshold: 0.5 })
    : null;
  function kaarten(m, fn) {
    if (!zicht) return;
    var lijst = m.querySelectorAll('.cn-koopje');
    for (var i = 0; i < lijst.length; i++) fn(lijst[i]);
  }

  function render(cart) {
    if (cart && Array.isArray(cart.items)) lastCart = cart;
    var c = lastCart;
    var mounts = document.querySelectorAll('.cn-koopjes-mount');
    for (var i = 0; i < mounts.length; i++) {
      var m = mounts[i];
      var pagina = m.classList.contains('cn-koopjes-mount--page');
      var lijst = c ? kies(c, pagina ? MAX_PAGINA : (D.max || 4)) : [];
      if (!lijst.length) {
        if (!m.hidden || m.innerHTML) {
          kaarten(m, function (el) { zicht.unobserve(el); });
          m.hidden = true; m.innerHTML = ''; m.removeAttribute('data-sig');
        }
        continue;
      }
      var sig = handtekening(lijst, pagina, c);
      if (m.getAttribute('data-sig') === sig && m.innerHTML) {
        m.hidden = false;
        /* Rij die al in de pagina stond (snippets/cn-koopjes-pagina.liquid):
           niet opnieuw tekenen, alleen swipen en meten aanzetten. */
        if (!m.cnKoopjesKlaar) {
          m.cnKoopjesKlaar = true;
          rijVolgen(m);
          kaarten(m, function (el) { zicht.observe(el); });
        }
        continue;
      }
      kaarten(m, function (el) { zicht.unobserve(el); });
      m.innerHTML = blokHtml(lijst, pagina);
      m.setAttribute('data-sig', sig);
      m.cnKoopjesKlaar = true;
      m.hidden = false;
      rijVolgen(m);
      kaarten(m, function (el) { zicht.observe(el); });
    }
  }

  function toonFout(knop) {
    var kaart = knop.closest('.cn-koopje');
    var info = kaart && kaart.querySelector('.cn-koopje__info');
    if (!info || info.querySelector('.cn-koopje__fout')) return;
    var p = document.createElement('p');
    p.className = 'cn-koopje__fout';
    p.setAttribute('role', 'alert');
    p.textContent = D.labels.fout || '';
    info.appendChild(p);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 4000);
  }

  /* De kaart blijft staan na toevoegen: het plusje wordt even een vinkje, en
     daarna kan de klant er nog een bij doen. */
  function bevestig(knop) {
    knop.disabled = false;
    if (!knop.isConnected) return;
    knop.classList.add('is-toegevoegd');
    knop.innerHTML = VINK;
    setTimeout(function () {
      knop.classList.remove('is-toegevoegd');
      knop.innerHTML = PLUS;
    }, 1400);
  }

  function voegToe(knop) {
    var k = koopje(knop.getAttribute('data-cn-koopje-add'));
    if (!k || bezig) return;
    var v = huidige(k);
    var kenmerken = { _koopje_id: String(k.id), _koopje_block: 'cart' };
    /* Zo telt de app een aankoop bij de juiste variant. De korting kijkt
       alleen naar _koopje_id. */
    var variant = AB ? abVariant() : '';
    if (variant === 'A' || variant === 'B') {
      kenmerken._koopje_test = String(AB.test);
      kenmerken._koopje_variant = variant;
    }
    bezig = true;
    knop.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: kenmerken }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('toevoegen ' + r.status);
        meld(k.id, 'add');
        return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        bevestig(knop);
        /* Lade opnieuw tekenen (de nieuwe regel met zijn korting), en de
           winkelwagenpagina, cadeaus en statiegeld laten bijwerken. */
        if (window.customCart && typeof window.customCart.refresh === 'function') window.customCart.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'add' } }));
      })
      .catch(function () {
        knop.disabled = false;
        toonFout(knop);
      })
      .then(function () { bezig = false; });
  }

  /* Vangen vóór de klik-afhandeling van de lade zelf. */
  document.addEventListener('click', function (e) {
    var pijl = e.target && e.target.closest ? e.target.closest('[data-cn-koopjes-pijl]') : null;
    if (pijl) {
      e.preventDefault();
      e.stopPropagation();
      var blok = pijl.closest('.cn-koopjes');
      var rij = blok && blok.querySelector('.cn-koopjes__rij');
      var kaart = rij && rij.querySelector('.cn-koopje');
      if (!rij) return;
      var stap = kaart ? kaart.getBoundingClientRect().width + 8 : rij.clientWidth * 0.8;
      var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rij.scrollBy({ left: Number(pijl.getAttribute('data-cn-koopjes-pijl')) * stap, behavior: rustig ? 'auto' : 'smooth' });
      return;
    }
    var knop = e.target && e.target.closest ? e.target.closest('[data-cn-koopje-add]') : null;
    if (!knop) return;
    e.preventDefault();
    e.stopPropagation();
    voegToe(knop);
  }, true);

  /* Andere smaak of maat: alleen deze kaart bijwerken (prijs en foto). */
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('[data-cn-koopje-keuze]') : null;
    if (!s) return;
    e.stopPropagation();
    var k = koopje(s.getAttribute('data-cn-koopje-keuze'));
    if (!k) return;
    keuze[k.id] = Number(s.value);
    var kaart = s.closest('.cn-koopje');
    var mount = s.closest('.cn-koopjes-mount');
    if (!kaart || !mount) return;
    var pagina = mount.classList.contains('cn-koopjes-mount--page');
    var v = huidige(k);
    var img = kaart.querySelector('.cn-koopje__foto');
    if (img && v.img) img.src = v.img;
    var prijs = kaart.querySelector('.cart-item__price-wrapper');
    if (prijs) prijs.outerHTML = prijsHtml(k, v, pagina);
    if (lastCart) mount.setAttribute('data-sig', handtekening(kies(lastCart, pagina ? MAX_PAGINA : (D.max || 4)), pagina, lastCart));
  }, true);

  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    render(cart);
    /* De winkelwagenpagina kan zichzelf daarna nog vervangen (lege of volle
       winkelwagen); dan staat er een lege mount. Even later nog een keer. */
    setTimeout(function () { render(); }, 450);
  });

  window.cnKoopjes = { render: render };

  function init() { render((window.CN_CART && window.CN_CART.cart) || null); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
